import {recommendationsDistanceInKm} from "../../application/constants/multi_lead/application_multi_lead_constants";
import {getStorageSentApplicationsIdListByOffer} from "../../application/utils/multi_lead/get_storage_sent_applications_id_list_by_offer";
import {IPropertyDetail} from "../../property/types/IPropertyDetail";

interface IProps {
    property: IPropertyDetail;
    filters: {
        minPrice?: string;
        maxPrice?: string;
    };
}

const RECOMMENDED_PROPERTIES_MAX_LENGTH = 6;

export const useRecommendedPropertiesPayload = (props: IProps) => {
    const {property, filters} = props;
    const excludedOfferIds = getStorageSentApplicationsIdListByOffer();

    return {
        page_size: RECOMMENDED_PROPERTIES_MAX_LENGTH,
        exclude_grouped: 1, // exclude offers from the same group of stages
        propertyId: property.id,
        excludedOfferIds,
        max_price: filters?.maxPrice,
        radius: recommendationsDistanceInKm.toString()
    };
};
import {recommendationsDistanceInKm} from "../../application/constants/multi_lead/application_multi_lead_constants";
import {getStorageSentApplicationsIdListByOffer} from "../../application/utils/multi_lead/get_storage_sent_applications_id_list_by_offer";
import {IPropertyDetail} from "../../property/types/IPropertyDetail";

interface IProps {
    property: IPropertyDetail;
    filters: {
        minPrice?: string;
        maxPrice?: string;
    };
}

const RECOMMENDED_PROPERTIES_MAX_LENGTH = 6;

export const useRecommendedPropertiesPayload = (props: IProps) => {
    const {property, filters} = props;
    const excludedOfferIds = getStorageSentApplicationsIdListByOffer();

    return {
        page_size: RECOMMENDED_PROPERTIES_MAX_LENGTH,
        exclude_grouped: 1, // exclude offers from the same group of stages
        propertyId: property.id,
        excludedOfferIds,
        max_price: filters?.maxPrice,
        radius: recommendationsDistanceInKm.toString()
    };
};
